import React from "react"
import { useTranslation } from "react-i18next"

import PublicLayout from "components/Layout/PublicLayout"
import { LeftWave, RightWave, Markdown } from "components/Elements"
import { Seo } from "components/Seo"

import { useAuth, useOperator } from "hooks"
import { ContactForm } from "./components"

export const ContactPage: React.FC = () => {
	const { isLoggedIn } = useAuth()
	const { t } = useTranslation()
	const { currentOperator, isBicycode } = useOperator()

	return (
		<PublicLayout>
			<div className="pt-10 lg:p-10">
				{currentOperator && (
					<>
						<Seo
							title={t("contact_title", {
								ns: "seo",
								operator: currentOperator.name,
							})}
						/>

						{isBicycode && !isLoggedIn && (
							<>
								<LeftWave className="fixed bottom-0 left-0" />
								<RightWave className="fixed bottom-0 right-0" />
							</>
						)}
					</>
				)}

				<h1 className={`c-h1 leading-tight mb-6 ${!isLoggedIn ? "text-center" : ""}`}>
					{t("menu.contact")}
				</h1>

				<div className="c-contact-page relative">
					<div className="px-4">
						<div className="max-w-screen-md mx-auto">
							<h2 className="c-h2 text-secondary text-center mb-6">
								{t("title", { ns: "contact" })}
							</h2>

							<div className="mb-6 text-center text-s">
								<Markdown>{t("description", { ns: "contact" })}</Markdown>
							</div>

							<div className="mb-6 text-center italic text-s">
								<Markdown>
									{t("fnuci_code_description", {
										ns: "contact",
										bc_exception: isBicycode
											? t("bc_exception", { ns: "contact" })
											: "",
									})}
								</Markdown>
							</div>

							<ContactForm isLoggedIn={isLoggedIn} />
						</div>
					</div>
				</div>
			</div>
		</PublicLayout>
	)
}
